import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WhoIsOnlineComponent} from './component/who-is-online/who-is-online.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {DxPopupModule} from 'devextreme-angular';
import {MaterialModule} from '../../../@material';
import {ReactiveFormsModule} from '@angular/forms';
import { UpdateInfoComponent } from './component/update-info/update-info.component';
import {LoadingDirectiveModule} from '../../../@shared/loading-directive/loading-directive.module';

@NgModule({
  declarations: [
    WhoIsOnlineComponent,
    UpdateInfoComponent,
  ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule,
        MatMenuModule,
        TranslateModule,
        DxPopupModule,
        MaterialModule,
        ReactiveFormsModule,
        LoadingDirectiveModule
    ],
  exports: [
    WhoIsOnlineComponent,
    UpdateInfoComponent
  ]
})
export class IdleAndWhoIsOnlineModule {
}
